	// =======================================================
	//  Author: JB    
	//  Date: 29/08/02  
	//  Description: Creates or updates a cookie
	//  Parameters received:
	//      String cookieName - name of cookie
	//      String cookieValue - value of cookie
	//  Parameters returned:
	//      None
	//  Modification history:
	// =======================================================
	function cookies_SetCookie (cookieName, cookieValue) {
		var argv = cookies_SetCookie.arguments;
		var argc = cookies_SetCookie.arguments.length;
		var expires = (argc > 2) ? argv[2] : null;
		var path = (argc > 3) ? argv[3] : null;
		var domain = (argc > 4) ? argv[4] : null;
		var secure = (argc > 5) ? argv[5] : false;
		var str = cookieName + "=" + escape (cookieValue) +
		((expires == null) ? "" : ("; expires=" + expires.toGMTString())) +
		((path == null) ? "" : ("; path=" + path)) +
		((domain == null) ? "" : ("; domain=" + domain)) +
		((secure == true) ? "; secure" : "");				
		document.cookie = str;
	}
	// =======================================================
	//  Author: JB                              
	//  Date: 29/08/02              
	//  Description: Returns the value of the cookie by "name" 
	//				 or null if the cookie does not exist
	//  Parameters received: 
	//      String cookieName - name of cookie
	//  Parameters returned: 
	//      None    
	//  Modification history: 
	// =======================================================
	//  
	function cookies_GetCookie (cookieName) {
		var arg = cookieName + "=";
		var alen = arg.length;
		var clen = document.cookie.length;
		var i = 0;
		while (i < clen) {
			var j = i + alen;
			if (document.cookie.substring(i, j) == arg) return cookies_getCookieVal (j);
			i = document.cookie.indexOf(" ", i) + 1;
			if (i == 0) break;
		}
		return null;
	}
//----------------------------------------------------------------------------------------------------
	// =======================================================
	//  Author: JB                              
	//  Date: 29/08/02              
	//  Description: Returns the value of the cookie by "name"
	//  Parameters received: 
	//      Integer offset - substring offset to get to cookie value
	//  Parameters returned: 
	//      String - value of cookie    
	//  Modification history: 
	// =======================================================
	function cookies_getCookieVal (offset) {
		var endstr = document.cookie.indexOf (";", offset);
		if (endstr == -1)
		endstr = document.cookie.length;
		return unescape(document.cookie.substring(offset, endstr));
	}
//----------------------------------------------------------------------------------------------------
	// =======================================================
	//  Author: JB                              
	//  Date: 29/08/02              
	//  Description: Function to delete a cookie. (Sets expiration date to current date/time)
	//  Parameters received: 
	//      String cookieName - name of cookie
	//  Parameters returned: 
	//      None    
	//  Modification history: 
	// =======================================================
	function cookies_DeleteCookie (cookieName) {
		var argv = cookies_DeleteCookie .arguments;
		var argc = cookies_DeleteCookie .arguments.length;
		var exp = new Date();
		exp.setDate (exp.getDate() - 1);  // This cookie is history
		var cval = cookies_GetCookie (cookieName);
                if( argc > 1 ) {
		    cookies_SetCookie( cookieName, null, exp, argv[1] );
                } else {
		    cookies_SetCookie( cookieName, null, exp );
                }
	}
//----------------------------------------------------------------------------------------------------






